
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PartnerWithDetails, PartnerPricing, Association } from '@/types/partner';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

interface PartnerCardProps {
  partner: PartnerWithDetails;
  associationType: Association['name'];
}

const PartnerCard = ({ partner, associationType }: PartnerCardProps) => {
  const navigate = useNavigate();
  
  console.log('Partner data in card:', partner);
  console.log('Association type in card:', associationType);

  // Get the pricing for this association type
  const pricing = partner.pricing?.find(
    p => partner.associations.some(
      a => a.id === p.association_id && a.name === associationType
    )
  );
  
  console.log('Pricing found for partner:', pricing);

  // Calculate short about description (first 10 words)
  const shortAbout = partner.about_us
    ? partner.about_us.split(' ').slice(0, 10).join(' ') + 
      (partner.about_us.split(' ').length > 10 ? '...' : '')
    : 'No description available';

  // Skip rendering if pricing not found
  if (!pricing) {
    console.log('No pricing found for partner, skipping render:', partner.id);
    return null;
  }
  
  const handleBookNow = () => {
    navigate(`/book-session?partnerId=${partner.id}&pricingId=${pricing.id}&associationType=${associationType}`);
  };

  return (
    <Card className="h-full">
      <CardContent className="p-6">
        <div className="flex flex-col gap-4">
          <div className="flex flex-col items-center text-center sm:flex-row sm:text-left sm:items-start gap-4">
            <Avatar className="w-20 h-20">
              <AvatarImage src={partner.profile_image} alt={partner.name} />
              <AvatarFallback className="text-xl">
                {partner.name.split(' ').map(n => n[0]).join('')}
              </AvatarFallback>
            </Avatar>
            
            <div className="flex-1">
              <h3 className="text-lg font-semibold">{partner.name}</h3>
              <p className="text-sm text-muted-foreground">
                {partner.education || 'Not specified'}
              </p>
              <p className="text-sm">
                <span className="font-medium">Experience:</span> {partner.experience || 0} years
              </p>
              <div 
                className="mt-2 text-sm group relative"
                title={partner.about_us || 'No description available'}
              >
                <p className="line-clamp-2">{shortAbout}</p>
                
                {partner.about_us && partner.about_us.split(' ').length > 10 && (
                  <div className="hidden group-hover:block absolute z-10 bg-white dark:bg-gray-800 p-4 rounded-md shadow-lg max-w-md left-0 top-full mt-1">
                    {partner.about_us}
                  </div>
                )}
              </div>
            </div>
          </div>
          
          <div className="flex justify-between items-center mt-2">
            <div>
              <p className="text-sm">
                <span className="font-medium">Session:</span> {pricing.min_session_time} min
              </p>
              <p className="text-sm font-semibold">
                {pricing.session_charge} {pricing.currency}
              </p>
            </div>
            
            <Button 
              variant="default" 
              onClick={handleBookNow}
            >
              Book Now
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PartnerCard;
